import { Link } from "react-router-dom";
import { Megaphone, LayoutTemplate, Search, Mail, Briefcase, Mail as MailIcon } from "lucide-react";
import { AdvertiseForm } from "../components/AdvertiseForm";
import { CONTACT_EMAIL } from "../lib/siteConfig";

const PLACEMENTS = [
  { icon: LayoutTemplate, title: "Homepage banner", text: "The first thing clients and crews see when they land on the site." },
  { icon: Search, title: "Category & search pages", text: "Sit next to the exact creatives your audience is looking for." },
  { icon: Briefcase, title: "Job board", text: "Reach working crew while they look for their next gig." },
  { icon: Mail, title: "Email newsletter", text: "A sponsor slot in our job-alert emails to Cape Town crews." },
];

export default function Advertise() {
  return (
    <div className="min-h-screen bg-background py-12 px-4 md:px-8" data-testid="advertise-page">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <p className="font-mono text-xs uppercase tracking-widest text-orange-500 flex items-center gap-2">
            <Megaphone className="h-4 w-4" /> Advertise With Us
          </p>
          <h1 className="font-heading text-title uppercase mt-3" data-testid="advertise-title">
            Advertise to Cape Town&apos;s <span className="text-orange-500">Film &amp; Video Crews</span>
          </h1>
          <p className="text-zinc-400 mt-3 max-w-2xl">
            Put your rental house, camera brand, studio or service in front of the people who make Cape Town&apos;s productions.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <aside className="space-y-4">
            {PLACEMENTS.map(({ icon: Icon, title, text }) => (
              <div key={title} className="bg-zinc-900 border border-zinc-800 p-5">
                <Icon className="h-5 w-5 text-orange-500 mb-2" />
                <h2 className="text-white font-medium">{title}</h2>
                <p className="text-zinc-500 text-sm mt-1">{text}</p>
              </div>
            ))}
            <p className="text-zinc-500 text-sm flex items-center gap-2">
              <MailIcon className="h-4 w-4" />
              <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-orange-500" data-testid="advertise-email">{CONTACT_EMAIL}</a>
            </p>
            <p className="text-zinc-500 text-sm">
              Not about advertising? <Link to="/contact" className="text-orange-500 hover:underline" data-testid="advertise-contact-link">Contact us</Link>
            </p>
          </aside>

          <section className="lg:col-span-2 bg-zinc-900 border border-zinc-800 p-6">
            <h2 className="font-heading text-xl text-white mb-2">Advertiser enquiry</h2>
            <p className="text-zinc-500 text-sm mb-6">Tell us what you&apos;d like to promote and we&apos;ll come back to you with options.</p>
            <AdvertiseForm testIdPrefix="advertise-page" />
          </section>
        </div>
      </div>
    </div>
  );
}
